module.exports = __webpack_public_path__ + "static/media/4ODA9.530de70a.jpg";